import React, { useState, useCallback, useRef } from 'react';

import { Form } from '@unform/web';
import { AnimatePresence } from 'framer-motion';
import { Container, Box, Input, Button } from './styles';

import { useAuth } from '../../hooks/AuthContext';

import NewLogo from '../../assets/New-Logo.svg';

import { ANIMATION } from './animations';

const Admin: React.FC = () => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const [isVisible, setIsVisible] = useState(true);
  const [hasErrors, setHasErrors] = useState(false);

  const { adminSignIn } = useAuth();

  const handleSubmit = useCallback(async () => {
    try {
      setIsVisible(false);

      await adminSignIn({
        email: emailRef.current.value,
        password: passwordRef.current.value,
      });
    } catch (err) {
      setIsVisible(true);
      setHasErrors(true);
    }
  }, [adminSignIn]);

  return (
    <AnimatePresence>
      {isVisible && (
        <Container>
          <Box
            variants={ANIMATION}
            initial="unMounted"
            animate="mounted"
            exit="unMounted"
          >
            <img src={NewLogo} alt="Bravosul" />

            <h1>Entre em sua conta</h1>
            <p>Digite as suas credencias para ter acesso a plataforma.</p>

            <Form onSubmit={handleSubmit}>
              <Input
                type="email"
                placeholder="Seu E-mail"
                required
                hasErrors={hasErrors}
                name="identifier"
                ref={emailRef}
              />
              <Input
                type="password"
                name="password"
                placeholder="Sua Senha"
                required
                ref={passwordRef}
                hasErrors={hasErrors}
              />

              <Button type="submit">Entrar</Button>
            </Form>
          </Box>
        </Container>
      )}
    </AnimatePresence>
  );
};

export default Admin;
